import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { intlShape } from 'react-intl';
import * as logger from 'universal-logger';
import config from 'universal-config';
import { userProfile } from 'redux/saga/entities/bound';
import { load as loadScript } from 'helpers/scripts';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';

export const getFriendbuyApi = () => (window.friendbuy = window.friendbuy || []);
export const getFriendbuyScript = countryCode => {
  if (countryCode === 'PHL') {
    return config().friendbuy.PHL.scriptUrl;
  }
  return config().friendbuy.default.scriptUrl;
};

export const getFriendbuySiteId = countryCode => {
  if (countryCode === 'PHL') {
    return config().friendbuy.PHL.siteId;
  }
  return config().friendbuy.default.siteId;
};

export function extractRafRewards(user) {
  const friendBuyInfo = (user && user.friendbuy_info) || {};
  const currencyFormat = friendBuyInfo.currency_format || '';
  const rafFallbackRewardAmount = friendBuyInfo.referral_reward > 0 ? friendBuyInfo.referral_reward : '';
  return {
    rafSenderReward: friendBuyInfo.sender_reward || `${currencyFormat}${rafFallbackRewardAmount}`,
    rafReceiverReward: friendBuyInfo.receiver_reward || `${currencyFormat}${rafFallbackRewardAmount}`,
  };
}

export const getFriendBuyContextVariables = state => {
  const profile = userProfile.data(state) || {};
  const { rafSenderReward, rafReceiverReward } = extractRafRewards(profile);
  return {
    $FIRST_NAME: profile.first_name,
    $FRIENDBUY_REWARD: rafSenderReward,
    $SENDER_FIRST_NAME: profile.first_name,
    $SENDER_REWARD: rafSenderReward,
    $RECEIVER_REWARD: rafReceiverReward,
  };
};

export class FriendbuyWidget extends Component {
  componentDidMount() {
    const { email, intl, userId, countryCode, widgetCode } = this.props;

    if (!widgetCode) {
      logger.warn(`FriendbuyWidget initiated without a widgetCode for user ${userId}.`);
      return;
    }

    if (!__TEST__ && !window.friendbuy) {
      loadScript(getFriendbuyScript(countryCode));
    }

    const friendbuy = getFriendbuyApi();
    friendbuy.push(['site', getFriendbuySiteId(countryCode)]);
    friendbuy.push([
      'track',
      'customer',
      {
        id: String(userId),
        email,
        locale: intl.locale,
      },
    ]);

    friendbuy.push([
      'widget',
      widgetCode,
      {
        configuration: {
          share_button: false,
        },
      },
    ]);

    friendbuy.push(['subscribe', 'share.success', this.handleShareSuccess]);
    friendbuy.push(['subscribe', 'widget.close', this.handleWidgetClose]);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleWidgetClose = ({ groupId, guid }) => {
    // Tinker with friendbuy's internal state so we can re-open the widget
    const friendbuy = getFriendbuyApi();

    if (friendbuy.widgets) {
      delete friendbuy.widgets[guid];
    }

    if (friendbuy.widgetPlacements) {
      Object.keys(friendbuy.widgetPlacements).forEach(name => {
        if (name.indexOf(groupId) === 0) {
          delete friendbuy.widgetPlacements[name];
        }
      });
    }

    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }
  };

  handleShareSuccess = () => {
    segment.track('raf-successfully-sent', {
      category: 'Refer-a-Friend',
      label: window.location.pathname,
      value: 0,
    });
    ga('Refer-a-Friend', 'raf-successfully-sent', window.location.pathname, 0);
  };

  render() {
    return <div className={`text--center friendbuy-${this.props.widgetCode}`} />;
  }
}

FriendbuyWidget.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  intl: intlShape,
  userId: PropTypes.number.isRequired,
  countryCode: PropTypes.string.isRequired,
  widgetCode: PropTypes.string.isRequired,
};
